import React from 'react'
import './data_card.css' 

const DataCard = ({metric, title}) => {
  return (
    <div className="card justify-content-center align-items-center " style={{ height:"160px", backgroundColor:'white', padding:"10px"}}>
      <h1 className="display-4" style={{margin:'0px'}}>
        {metric}
      </h1>
      <div className="d-flex justify-content-center align-items-center card-text" >
        <h5 className="text-center text-wrap" style={{lineHeight:'1.3', fontWeight:'500', margin:"0px"}}>
          {title}
        </h5> 
      </div>
    </div>
  )
}

export default DataCard